/*eslint camelcase: ["error", {properties: "never"}]*/
import React, { useState } from 'react';
import { Divider } from 'primereact/divider';
import { AgentFilter } from './agentFilter/AgentFilter';
import {  CoachingInsightFeedbackTable } from './coachingInsightFeedbackTable/CoachingInsightFeedbackTable';

export const CoachingInsightFeedback = () => {
    const [agentNumbers, setAgentNumbers] = useState<string[]>([]);
    const [dateRange, setDateRange] = useState<Date[]>([]);
    return (
          <>
          <AgentFilter selectedAssociate={setAgentNumbers} selectedDateRange={setDateRange} />
          <Divider />
          <div className="row mt-2">
          <CoachingInsightFeedbackTable agentNumbers={agentNumbers} selectedDates={dateRange} />
          </div></>
    );
};
